<template>
  <div class="page-banner">
    <img src="../../../assets/coursePage/inseec/box1/banner.png" alt="" />
  </div>
</template>

<script>
  export default {
    name: "",
    data() {
      return {};
    },
  };
</script>

<style lang="scss" scoped>
  .page-banner {
    img {
      width: 100%;
    }
  }
</style>
